(() => {
  'use strict';
  const element = document.getElementById('FultonsExactCheckoutData');
  if (!element) return;
  let data;
  try { data = JSON.parse(element.textContent); } catch { return; }
  const selected = new WeakMap();
  const allowedKinds = new Set(['fast-track-recliner', 'fast-track-office']);
  const quantityRule = (variant, price) => {
    const rule = variant.quantityRule || {};
    const min = Number(rule.min ?? 1), step = Number(rule.increment ?? 1);
    const maximum = rule.max == null ? Infinity : Number(rule.max);
    const max = Math.min(maximum, Math.floor(499999 / price));
    if (!Number.isInteger(min) || min < 1 || !Number.isInteger(step) || step < 1 || !Number.isInteger(max) || max < min) return null;
    return { min, max, step };
  };
  const validQuantity = (value, rule) => {
    const quantity = Number(value);
    return Boolean(rule && Number.isInteger(quantity) && quantity >= rule.min && quantity <= rule.max && (quantity - rule.min) % rule.step === 0);
  };
  const resolve = (selection, day = new Date().toISOString().slice(0, 10)) => {
    const empty = { variantId: null, sku: '', matched: false, available: false, canCheckout: false };
    if (data.vendor !== 'Stressless' || data.currency !== 'GBP' || !allowedKinds.has(data.kind)) return empty;
    if (!selection || String(selection.productId) !== data.productId || selection.kind !== data.kind || selection.complete !== true || !selection.key) return empty;
    const approved = data.prepared.filter(item => item.selectionKey === selection.key && item.kind === selection.kind && item.productId === data.productId);
    if (approved.length !== 1) return empty;
    const expected = approved[0];
    const variants = data.variants.filter(item => item.id === expected.id && item.title === expected.variantTitle);
    if (variants.length !== 1 || expected.productTitle !== data.title) return empty;
    const variant = variants[0], price = Math.round(Number(selection.priceGbp) * 100);
    if (!Number.isInteger(price) || price <= 0 || price >= 500000 || price !== expected.price || price !== variant.price || expected.vatIncluded !== true || expected.priceVerified !== true) return empty;
    const rule = quantityRule(variant, price);
    const hasEstimate = typeof expected.deliveryEstimate === 'string' && expected.deliveryEstimate.trim();
    const supplierConfirmed = expected.supplierAvailabilityConfirmed === true && /^\d{4}-\d{2}-\d{2}$/.test(expected.availabilityValidUntil || '') && day <= expected.availabilityValidUntil;
    const merchantAssumed = expected.merchantAvailabilityAssumed === true && expected.availabilityBasis === 'merchant-planning-assumption' && /^\d{4}-\d{2}-\d{2}$/.test(expected.availabilityRecordedOn || '') && expected.availabilityRecordedOn <= day;
    const availabilityApproved = Boolean(hasEstimate && (supplierConfirmed || merchantAssumed));
    return { variantId: variant.id, sku: variant.sku, price, quantityRule: rule, matched: true, available: variant.available === true, canCheckout: data.onlineEnabled === true && variant.available === true && availabilityApproved && Boolean(rule) };
  };
  const update = (selection, root) => {
    const match = resolve(selection);
    if (!root) return match;
    selected.set(root, selection);
    root.dataset.onlineCandidateKind = selection?.kind || '';
    root.dataset.exactVariantId = match.variantId || '';
    root.dataset.exactVariantMatched = String(match.matched);
    root.dataset.onlineCheckoutEnabled = String(match.canCheckout);
    if (!root.querySelector('[data-fultons-purchase]')) {
      const template = document.querySelector('template[data-fultons-purchase-template]');
      const enquiry = root.querySelector('[data-stressless-offer] [data-stressless-enquire]');
      if (template && enquiry) enquiry.before(template.content.cloneNode(true));
    }
    root.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      const input = form.querySelector('[name="id"]');
      if (input) { input.value = match.canCheckout ? match.variantId : ''; input.disabled = !match.canCheckout; }
      form.querySelectorAll('[type="submit"],.shopify-payment-button').forEach(control => { control.disabled = !match.canCheckout; control.hidden = !match.canCheckout; });
      const panel = form.closest('[data-fultons-purchase]');
      if (panel) panel.hidden = !match.matched;
      const controls = form.querySelector('.fultons-online-purchase__controls');
      if (controls) controls.hidden = !match.canCheckout;
      const quantity = form.querySelector('[name="quantity"]');
      if (quantity) {
        quantity.disabled = !match.canCheckout;
        if (match.quantityRule) {
          quantity.min = String(match.quantityRule.min);
          quantity.max = String(match.quantityRule.max);
          quantity.step = String(match.quantityRule.step);
          if (!validQuantity(quantity.value, match.quantityRule)) quantity.value = String(match.quantityRule.min);
        }
      }
    });
    return match;
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
    if (form.matches('[data-ethnicraft-purchase-form]')) return;
    const root = form.closest('.catalogue-proof,.pdp-refined');
    const match = resolve(root && selected.get(root));
    const values = new FormData(form);
    if (!match.canCheckout || String(values.get('id')) !== match.variantId || !validQuantity(values.get('quantity'), match.quantityRule)) {
      event.preventDefault(); event.stopImmediatePropagation();
      const error = form.querySelector('[data-purchase-error]');
      if (error) { error.textContent = form.dataset.validationMessage; error.hidden = false; }
      update(root && selected.get(root), root);
    }
  }, true);
  window.FultonsExactCheckout = {
    resolve, update,
    requestedSize(id) {
      if (String(id) !== data.productId) return null;
      const requested = new URL(location.href).searchParams.get('variant');
      const matches = data.prepared.filter(item => item.id === requested);
      return matches.length === 1 ? matches[0].variantTitle : null;
    }
  };
  document.dispatchEvent(new CustomEvent('fultons:exact-checkout-ready'));
})();

